export default function ThemeToggle({ theme, onToggle, variant = 'default', className = '' }) {
  const dark = theme === 'dark';
  const nextLabel = dark ? 'Modo claro' : 'Modo oscuro';

  return (
    <button
      type="button"
      className={`theme-toggle theme-toggle--${variant} ${className}`.trim()}
      onClick={onToggle}
      aria-label={`Activar ${nextLabel.toLowerCase()}`}
      aria-pressed={dark}
      title={nextLabel}
    >
      <span className="theme-toggle__icon" aria-hidden="true">{dark ? '☀' : '☾'}</span>
      <span className="theme-toggle__label">{nextLabel}</span>
    </button>
  );
}
